import { useFilterHolidayTypeContext } from "./filter-holiday-type.context";

export function FilterHolidayType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterHolidayTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}